import Toast from '../constants/constants';
import ApiCalls from '../classes/ApiCalls';

export class ConferenceRepository
{
    create()
    {
        backdrop.show('Creating Conference...Please wait!');
        let form = $('#create-conference-form');
        let formData = form.serialize();

        let success = function(response){
            backdrop.hide();
            Toast.fire({
                icon: response.type,
                title: response.title
            });
            if (response.type === 'success'){
                setTimeout(function(){
                    window.location.href = response.redirect
                }, 1000);
            }
        }
        let errorMessage = 'Failed to create Conference. Please check your connection and try again or contact your System Administrator';

        new ApiCalls(formData, form.attr('action'), success, errorMessage).dispatch()
    }
}
